import { createSlice } from '@reduxjs/toolkit';
// utils

// ----------------------------------------------------------------------

import apiFacebook from '../../api/facebook';
import useAuth from '../../hooks/useAuth';
function objFromArray(array, key = 'id') {
  return array.reduce((accumulator, current) => {
    accumulator[current[key]] = current;
    return accumulator;
  }, {});
}

const initialState = {
  isLoading: false,
  facebook: { error: "", description: "", name: "", avatar: "", cover: "", oa_id: "", is_verified: "" },
  info: { error: "", description: "", name: "", avatar: "", cover: "", oa_id: "", is_verified: "", page_id: "", access_token: "" },
  manage_page: [{ avatar: "", role: "", avatarUrl: "", id: "", name: "", access_token: "" }]
};
//0
// name : teen store quan li
const slice = createSlice({
  name: 'Facebook',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },
    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },
    //GET INFO Facebook
    getInfoFacebookSuccess(state, action) {
      state.facebook = { ...action.payload.data };
    },
    getAccessFacebookSuccess(state, action) {
      if (action.payload.data) {
        state.facebook = { ...action.payload.data };
      }
    },
    getLoadListPageSuccess(state, action) {
      const participants = action.payload;
      if (participants.data.length && participants.data.length > 0) {
        state.manage_page = participants.data.length < 5 ? participants.data.concat([{ avatar: "", role: "", avatarUrl: "", id: "", name: "", access_token: "" }]) : participants.data;
      } else {
        state.manage_page = [{ avatar: "", role: "", avatarUrl: "", id: "", name: "", access_token: "" }];
      }
    },

  }
});

// Reducer
export default slice.reducer;


//---------------------------INFO OA Facebook-------------------------------------------
//TYPE :  POST
//PARAM : Header:{ access_token}
//RESPONSE
// oa_id |	long	ID của OA được lấy thông tin
// description | 	string	Mô tả của OA
// name |	string	Tên của OA
// avatar	| string	Đường dẫn đến ảnh đại diện của OA
// cover | string|	Đường dẫn đến ảnh bìa của OA
// is_verified | 	boolean	| Trạng thái xác thực của OA ( false: OA chưa được xác thực ,true: OA đã xác thực)  

// ----------------------------------------------------------------------
export function getAccessFacebook(param, user) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {

      const response = await apiFacebook.accessToken({ access_token: param.accessToken, user_id: param.userID, admin_id: param.admin_id });
      const response_update_list_page = await apiFacebook.listPage();

      dispatch(slice.actions.getLoadListPageSuccess({ data: response_update_list_page.data.data, user: user }));
      dispatch(slice.actions.getAccessFacebookSuccess(response.data.data));
    } catch (error) {
      console.log(error)
      dispatch(slice.actions.hasError(error));
    }
  };
}
export function loadListPage(user) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await apiFacebook.listPage();
      var page_ids=[];
      response.data.data.map(page =>page_ids.push(page.id))
      localStorage.setItem('page_ids',JSON.stringify(page_ids))
      dispatch(slice.actions.getLoadListPageSuccess({ data: response.data.data, user: user }));
    } catch (error) {
      console.log(error)
      dispatch(slice.actions.hasError(error));
    }
  };
}
export function getInfoFacebook(param) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {

      const response = await apiFacebook.getInfo();
      console.log(response);
      dispatch(slice.actions.getInfoFacebookSuccess(response.data.data));
    } catch (error) {
      console.log(error)
      dispatch(slice.actions.hasError(error));
    }
  };
}
